// Starter identity comes from API plan data, never from navigation metadata.
export function starterPlanIdentity(plan) {
  const key = typeof plan?.starterTemplateKey === "string" && plan.starterTemplateKey.trim()
    ? plan.starterTemplateKey : null;
  return { isStarter: plan?.starterTemplate === true || key !== null, key };
}

export function starterPlanSearch(search, plan) {
  const params = new URLSearchParams(search);
  const { isStarter, key } = starterPlanIdentity(plan);
  if (isStarter) params.set("type", "starter");
  else params.delete("type");
  if (isStarter && key !== null) params.set("starter_key", key);
  else params.delete("starter_key");
  const result = params.toString();
  return result ? `?${result}` : "";
}

const searchFields = ["tab", "mmp-friendly", "query", "offset", "content", "wp-type", "tools", "ratings", "allergens", "categories"];

export function plannerViewLocation(location, view, mealId) {
  const params = new URLSearchParams(location.search);
  params.set("v", view);
  params.delete("id");
  if (view === "meal" && mealId != null) params.set("id", mealId);
  if (view !== "search") searchFields.forEach(field => params.delete(field));
  return { ...location, search: `?${params.toString()}` };
}
